<!-- Willy en plein écran, comme une messagerie (PC-09b, maquette 12) : en-tête
     collant, fil qui défile, saisie collée en bas de la feuille. -->
<div class="flex h-full flex-col bg-vw-surface">
  <vw-ai-chatbot-header [showMenu]="!isGuest" [lastAnswer]="lastAnswer" (newConversation)="onNewConversation()"
    (closeRequested)="closeRequested.emit()"></vw-ai-chatbot-header>
  @if (isGuest) {
    <!-- Invité (P5.5) : la carte du mur du quota, avec un bouton « Créer mon
         compte », au lieu d'un mode d'emploi en quatre étapes. Willy se
         referme quand l'inscription s'ouvre. -->
    <div class="flex min-h-0 flex-1 flex-col justify-center overflow-y-auto px-4 py-6">
      <vw-guest-signup-card source="willy" titleKey="guest.signup.willy.title"
        messageKey="guest.signup.willy.message" (signup)="closeRequested.emit()"></vw-guest-signup-card>
    </div>
  }
  @if (!isGuest) {
    <div #thread class="flex min-h-0 flex-1 flex-col gap-3 overflow-y-auto px-4 py-4" aria-live="polite">
      @for (m of messages; track $index; let i = $index) {
        @if (m.notice === 'free-photo-used') {
          <!-- Une fois, après la réponse : le diagnostic offert a servi (CR-05). -->
          <vw-premium-teaser
            [compact]="true"
            [message]="'willy.free-photo.used' | translate"
            [detail]="'willy.free-photo.used-detail' | translate"
            source="willy_photo"
            (ctaClicked)="openPaywall('willy_photo')"
          ></vw-premium-teaser>
        } @else if (m.role === 'assistant') {
          <div class="flex max-w-[88%] items-start gap-2 self-start">
            <img src="/assets/images/willy/willy_hi.webp" alt="" class="h-8 w-8 shrink-0 rounded-pill bg-vw-surface-tint object-contain">
            <div class="flex min-w-0 flex-col items-start gap-1">
              <div class="select-text whitespace-pre-line rounded-card border border-vw-line bg-vw-surface px-3 py-2 text-body text-vw-ink">{{ m.text }}</div>
              @if (m.copyable) {
                <button type="button" class="flex min-h-target items-center gap-1 px-2 text-body-s font-semibold text-vw-primary active:bg-vw-surface-sunk"
                  (click)="copy(m, i)">
                  <vw-copy-icon class="h-4 w-4" />{{ (copiedIndex === i ? 'willy.copied' : 'willy.copy') | translate }}
                </button>
              }
            </div>
          </div>
        } @else {
          <div class="flex max-w-[85%] flex-col items-end gap-1 self-end">
            @if (m.photoUrls?.length) {
              <div class="flex flex-wrap justify-end gap-1">
                @for (url of m.photoUrls; track url) {
                  <img [src]="url" class="size-16 rounded-field object-cover" alt="">
                }
              </div>
            }
            @if (m.text) {
              <div class="select-text whitespace-pre-line rounded-card bg-vw-primary px-3 py-2 text-body text-vw-on-color">{{ m.text }}</div>
            }
          </div>
        }
      }
      @if (willyLoading) {
        <div class="flex items-start gap-2 self-start">
          <img src="/assets/images/willy/willy_hi.webp" alt="" class="h-8 w-8 shrink-0 rounded-pill bg-vw-surface-tint object-contain">
          <div class="willy-typing flex h-10 items-center gap-1 rounded-card border border-vw-line bg-vw-surface px-4" role="status">
            <span class="sr-only">{{ 'willy.thinking' | translate }}</span>
            <i></i><i></i><i></i>
          </div>
        </div>
      }
      @if (sendError) {
        <div class="flex items-center gap-2 pl-10" role="alert">
          <vw-info-icon class="flex h-5 w-5 shrink-0 text-vw-danger" />
          <p class="grow text-body-s text-vw-danger">{{ sendError | translate }}</p>
          <vw-button look="secondary" size="small" label="willy.retry" (onClick)="retry()"></vw-button>
        </div>
      }
      <!-- Le mur du jour garde son ton : une carte, dans le fil, pas une alerte. -->
      @if (isQuotaExhausted) {
        <div class="flex items-start gap-3 rounded-card bg-vw-surface-tint p-4">
          <img src="/assets/images/willy/willy_busy.webp" alt="" class="h-14 w-14 shrink-0 object-contain">
          <div class="grow">
            <p class="text-body font-semibold text-vw-primary-ink">{{ 'willy.wall.title' | translate }}</p>
            <p class="mt-1 text-body-s text-vw-primary-ink">{{ 'willy.wall.detail' | translate }}</p>
          </div>
        </div>
      }
    </div>

    <div class="shrink-0 border-t border-vw-line bg-vw-surface pb-2 pt-3">
      <!-- Hors réseau : le bandeau ambre de l'app (accueil, notifications), pas un bandeau noir. -->
      <vw-offline-banner class="mx-4 mb-3 block" [active]="isOffline" titleKey="willy.offline-banner.title"
        messageKey="willy.offline" (retry)="checkConnection()"></vw-offline-banner>
      <vw-ai-chatbot-input-message
        [disabled]="composerDisabled"
        [placeholderKey]="composerPlaceholder"
        [photoLocked]="photoLocked"
        (photoLockedClick)="onPhotoLocked()"
        (messageSubmitted)="sendMessageToWilly($event)"
        (inputFocus)="onInputFocus()"
        (inputBlur)="onInputBlur()"></vw-ai-chatbot-input-message>
      <!-- Le décompte, une ligne sous le champ (K11) ; au mur, l'offre en lien. -->
      @if (showQuotaLine && !isOffline) {
        <p class="mt-2 px-4 text-center text-body-s text-vw-muted">
          {{ 'willy.quota.remaining' | vwPlural: quotaRemaining }}
          @if (isQuotaExhausted) {
            <button type="button" class="font-semibold text-vw-primary underline" (click)="openPaywall('willy_quota_reached')">
              {{ 'willy.quota.unlimited' | translate }}
            </button>
          }
        </p>
      }
    </div>
  }
</div>

<vw-premium-toast
  [isOpen]="premiumPaywallOpen"
  [source]="premiumPaywallSource"
  (close)="premiumPaywallOpen = false"
></vw-premium-toast>
